import CommentController from "components/ReuseableCompos/CommentsForm/CommentController";
import useTranslation from "next-translate/useTranslation";
import { memo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import useInputValueLangaugeDetector from "../../../customHooks/useInputValueLangaugeDetector";
import { addDays, addMonths } from "../../../utils/dateHelpers";
import CustomDatePicker from "../../ReuseableCompos/CustomDatePicker";
const Step2 = ({ isProfile }) => {
  const {
    register,
    control,
    watch,
    clearErrors,
    
    formState: { errors },
  } = useFormContext();


  const { t } = useTranslation("common");

  const details = register("details");

  return (
    <div>
      {!isProfile && (
        <>
          <div className="mb-3">
            <label htmlFor="date" className=" fs-lg px-1">
              {t(`event_date`)}
            </label>
            <div className="">
              <Controller
                name={"date"}
                control={control}
                render={({ field: { onChange, value } }) => {
                  return (
                    <CustomDatePicker
                      onChange={(e) => onChange(e?.toISOString().split("T")[0])}
                      startDate={new Date(value)}
                      placeholderText="Enter your birth date"
                      inputClassName="w-100"
                      maxDate={addMonths(new Date(), +6)}
                      minDate={addDays(new Date(), -2)}
                    />
                  );
                }}
              />
            </div>
            <div className="invalid-feedback">
              {t(errors.date?.message as string)}
            </div>
          </div>
        </>
      )}
      <label htmlFor="details" className=" fs-lg px-1">
        {t(`event_details`)}
      </label>
      <CommentController
        control={control}
        watch={watch}
        name="details"
        placeholder={t(`event_details_placeholder`)}
      />
    </div>
  );
};

export default memo(Step2);
